import { useMemo } from 'react';
import { InternalLink, LinkBlockLink } from '../@types/schema';
import cleanLinks from './clean-links';

interface InternalLinksProps {
  internalLinks: InternalLink[] | LinkBlockLink[];
  title: string;
}

// Abstract component
const InternalLinks = ({ internalLinks, title }: InternalLinksProps) => {
  const cleanedLinks = useMemo(() => cleanLinks(internalLinks), [internalLinks]);
  if (!cleanedLinks?.length) return null;

  return (
    <>
      <div className="text-base font-bold mb-1">{title}</div>
      <ul
        className="
        lg:text-sm leading-5 mb-4 flex flex-wrap flex-col md:flex-row -mx-2
        [&>li]:relative [&>li]:after:absolute [&>li]:after:block [&>li]:after:top-2 [&>li]:after:right-0 [&>li]:after:bottom-2 [&>li]:after:md:border-r-gray-400 [&>li]:after:md:border-r-[1px] [&>li:last-child]:after:md:border-r-0"
      >
        {cleanedLinks.map((link) => (
          <li key={link.label}>
            <a
              aria-label={`Link to ${link.label}`}
              className="hover:text-primary hover:underline block p-2 md:py-1"
              href={link.link?.toLowerCase()}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};

export default InternalLinks;
